<template>
  <div class="properies-form">
    <v-card class="subtitle-1">
      <v-card-text>
        <v-card
          v-if="properties && properties.length > 0"
          outlined
          class="properies-form-font mb-3 elevation-3"
        >
          <v-card-title class="secondary">
            <v-icon large left color="blue"> mdi-folder-open </v-icon>
            <span class="font-weight-dark">مشخصات مشترک </span>
          </v-card-title>

          <v-card-text>
            <show-properties :properties="properties"></show-properties>
          </v-card-text>
        </v-card>
        <v-card
          v-if="
            selectedProductProperties && selectedProductProperties.length > 0
          "
          outlined
          class="properies-form-font mb-3 elevation-3"
        >
          <v-card-title class="secondary">
            <v-icon large left color="blue darken-4"> mdi-book-open </v-icon>
            <span class="font-weight-dark">مشخصات اختصاصی </span>
          </v-card-title>
          <v-card-text>
            <v-form ref="ProductForm" v-model="ProductValid">
              <v-row
                class="mt-1"
                v-if="
                  selectedProductProperties && selectedProductProperties?.length
                "
              >
                <v-col
                  v-for="(item, i) in selectedProductProperties"
                  :key="i"
                  cols="12"
                  :sm="item.propertyType == 'Number' ? 12 : 4"
                  :md="item.propertyType == 'Number' ? 12 : 4"
                >
                  <new-files-uploader
                    v-if="item.propertyType == 'File'"
                    :files="item.value ? item.value : []"
                    ref="filesUploder"
                    :title="item.title"
                    :required="item.required"
                    :requiredText="item.requiredText"
                    :singleFile="true"
                    @fileChanged="(e) => (item.value = e)"
                  ></new-files-uploader>
                  <v-text-field
                    dense
                    v-if="item.propertyType == 'Text' && item.required"
                    required
                    :label="item.title"
                    :rules="[(v) => !!v || item.requiredText]"
                    v-model="item.value"
                    outlined
                    class="mt-1"
                  ></v-text-field>
                  <v-text-field
                    class="mt-1"
                    :label="item.title"
                    dense
                    v-if="item.propertyType == 'Text' && !item.required"
                    v-model="item.value"
                    outlined
                  ></v-text-field>
                  <v-row v-if="item.propertyType == 'Number'">
                    <v-col cols="12" :md="item.setMaxValue ? '2' : '3'" sm="6">
                      <v-text-field
                        :style="{ direction: 'ltr', 'text-align': 'right' }"
                        type="number"
                        :label="
                          item.setMaxValue
                            ? `حد پایین ${item.propertyTitle}`
                            : item.propertyTitle
                        "
                        dense
                        v-if="item.propertyType == 'Number' && item.required"
                        required
                        :rules="[
                          (v) => !!v || item.requiredText,
                          (v) =>
                            /^-?\d*[.]?\d*$/.test(v) ||
                            'لطفا فقط عدد وارد کنید',
                        ]"
                        v-model="item.value"
                        outlined
                        class="mt-1"
                      ></v-text-field>
                      <v-text-field
                        :style="{ direction: 'ltr', 'text-align': 'right' }"
                        type="number"
                        :label="
                          item.setMaxValue
                            ? `حد پایین ${item.title}`
                            : item.title
                        "
                        :rules="[
                          (v) => {
                            if (v == undefined) return true;
                            return (
                              /^-?\d*[.]?\d*$/.test(v) ||
                              'لطفا فقط عدد وارد کنید'
                            );
                          },
                        ]"
                        dense
                        v-if="item.propertyType == 'Number' && !item.required"
                        v-model="item.value"
                        outlined
                        class="mt-1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" sm="6" v-if="item.setMaxValue">
                      <v-text-field
                        :style="{ direction: 'ltr', 'text-align': 'right' }"
                        type="number"
                        :label="'حد بالا ' + item.title"
                        dense
                        :rules="[
                          (v) =>
                            /^-?\d*[.]?\d*$/.test(v) ||
                            'لطفا فقط عدد وارد کنید',
                        ]"
                        v-model="item.maxValue"
                        outlined
                        class="mt-1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" :md="item.setMaxValue ? '2' : '3'" sm="6">
                      <v-select
                        dense
                        v-if="
                          item.propertyType == 'Number' && item.units?.length
                        "
                        :items="item.units"
                        v-model="item.mid"
                        :label="
                          'واحد اندازه گیری ' +
                          item.measurementQuantityDisplayText
                        "
                        item-text="displayText"
                        item-value="id"
                        class="mt-1"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      sm="6"
                      v-if="
                        categoryType == 'Product' ||
                        categoryType == 'IndustrialService'
                      "
                    >
                      <v-checkbox
                        v-model="item.setMaxValue"
                        label="تعریف حد بالا"
                      >
                      </v-checkbox>
                    </v-col>
                  </v-row>
                  <v-select
                    :label="item.title"
                    dense
                    v-if="item.propertyType == 'SelectList' && item.required"
                    required
                    :rules="[(v) => !!v || item.requiredText]"
                    :items="item.listValues"
                    v-model="item.value"
                    item-text="title"
                    item-value="title"
                    class="mt-1"
                    clearable
                    outlined
                  ></v-select>
                  <v-select
                    :label="item.title"
                    dense
                    v-if="item.propertyType == 'SelectList' && !item.required"
                    :items="item.listValues"
                    v-model="item.value"
                    item-text="title"
                    item-value="title"
                    class="mt-1"
                    clearable
                    outlined
                  ></v-select>
                  <v-select
                    :label="item.title"
                    dense
                    v-if="
                      item.propertyType == 'MultiSelectList' && item.required
                    "
                    required
                    :rules="[(v) => !!v || item.requiredText]"
                    :items="item.listValues"
                    v-model="item.value"
                    item-text="title"
                    item-value="title"
                    class="mt-1"
                    clearable
                    multiple
                    outlined
                  ></v-select>
                  <v-select
                    :label="item.title"
                    dense
                    v-if="
                      item.propertyType == 'MultiSelectList' && !item.required
                    "
                    :items="item.listValues"
                    v-model="item.value"
                    item-text="title"
                    item-value="title"
                    class="mt-1"
                    clearable
                    multiple
                    outlined
                  ></v-select>
                  <v-checkbox
                    v-if="item.propertyType == 'Logical'"
                    v-model="item.value"
                    :label="item.title"
                    small
                    dense
                  ></v-checkbox>
                  <v-text-field
                    :label="item.title"
                    v-if="item.propertyType == 'Date' && item.required"
                    :id="'DPicker' + i"
                    dense
                    outlined
                    class="mt-1"
                    v-model="item.value"
                    clearable
                    readonly
                    required
                    :rules="[(v) => !!v || item.requiredText]"
                    prepend-inner-icon="mdi-calendar-range"
                  ></v-text-field>
                  <v-text-field
                    :label="item.title"
                    v-if="item.propertyType == 'Date' && !item.required"
                    :id="'DPicker' + i"
                    dense
                    outlined
                    class="mt-1"
                    v-model="item.value"
                    clearable
                    readonly
                    prepend-inner-icon="mdi-calendar-range"
                  ></v-text-field>
                  <date-picker
                    :label="item.title"
                    v-model="item.value"
                    :element="'DPicker' + i"
                    v-if="item.propertyType == 'Date'"
                    class="mt-1"
                  >
                  </date-picker>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-title class="properies-form-font"
            >ویژگی پیشنهادی</v-card-title
          >
          <v-card-subtitle class="properies-form-font">
            مشخصات که بنظر شما در لیست مشخصات ارائه نشده از این بخش اضافه شود.
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-checkbox
                  hide-details
                  class="mt-0 mb-2"
                  v-model="propertySuggestions"
                >
                  <template v-slot:label>
                    <div class="properies-form-font">
                      نیاز به ثبت مشخصات اضافه دارم.
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-form
              ref="propertySuggestionForm"
              v-model="propertySuggestionValid"
              v-if="propertySuggestions"
            >
              <div
                cols="12"
                class="py-0"
                v-for="(
                  propertySuggestion, index
                ) in product.propertySuggestions"
                :key="index"
              >
                <v-row>
                  <v-col cols="1" class="py-0">
                    <v-btn
                      icon
                      color="error"
                      @click="removePropertySuggestion(index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>

                  <v-col cols="12" sm="11" md="8">
                    <v-text-field
                      label="* عنوان"
                      required
                      :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                      outlined
                      dense
                      v-model="propertySuggestion.title"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-form>
            <v-tooltip
              right
              @click="addPropertySuggestion()"
              v-if="propertySuggestions"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="addPropertySuggestion()"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-plus-circle </v-icon>
                </v-btn>
              </template>
              <span> افزودن</span>
            </v-tooltip>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn
          @click="beforeStep()"
          color="secondery"
          v-if="!$store.getters.supplierProductIsEdit"
        >
            بازگشت به مرحله قبل
        </v-btn>
        <v-btn @click="nextStep()" color="primary">  مرحله بعد </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import NewFilesUploader from '@/components/core/NewFilesUploader.vue';
import ShowProperties from '@/components/core/showProperties.vue';
import Swal from 'sweetalert2';
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    NewFilesUploader,
    ShowProperties,
  },
  props: {
    properties: {
      default: [],
      type: Array,
    },
    isSelectedProduct: {
      default: false,
      type: Boolean,
    },
    categoryType: {
      type: String,
      default: null,
    },
    selectedProductProperties: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      product: {
        properties: [],
        propertySuggestions: [],
      },
      ProductValid: true,
      propertySuggestions: false,
      propertySuggestionValid: true,
    };
  },
  created() {
    if (
      this.$store.getters.supplierProductSelectedForEdit &&
      this.$store.getters.supplierProductSelectedForEdit?.properties
    ) {
      if (
        this.$store.getters.supplierProductSelectedForEdit
          .propertySuggestions &&
        this.$store.getters.supplierProductSelectedForEdit.propertySuggestions
          ?.length > 0
      ) {
        this.propertySuggestions = true;
        this.product.properties =
          this.$store.getters.supplierProductSelectedForEdit.properties; // this.properties;
      }
      this.product.propertySuggestions =
        this.$store.getters.supplierProductSelectedForEdit.propertySuggestions;
      this.product.properties =
        this.$store.getters.supplierProductSelectedForEdit.properties; //this.properties;
    } else {
      this.product.properties =
        this.$store.getters.supplierProductSelectedForEdit?.properties; // this.properties;
    }
  },
  watch: {
    properties(after, before) {
      this.product.properties = after;
    },
    propertySuggestions(after, before) {
      if (after && !this.product.propertySuggestions?.length) {
        this.product.propertySuggestions.push({
          title: '',
          value: '',
          listValues: [],
        });
      } else if (after) {
      } else {
        this.product.propertySuggestions = [];
      }
    },
  },
  beforeDestroy() {
    this.product = {
      properties: [],
      propertySuggestions: [],
    };
  },
  methods: {
    openImage(url) {
      window.open(url, '_blank');
    },
    beforeStep() {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: 'در صورت بازگشت به قبل، اطلاعات ثبت شده مقادیر ویژگی حذف و در صورت تغییر دسته بندی کلیه اطلاعات ثبت حذف خواهد شد ',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'لغو',
        confirmButtonText: 'بلی، بازگشت به عقب انجام  شود',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('goToCategoryStep');
        }
      });
    },
    removePropertySuggestion(index) {
      this.product.propertySuggestions.splice(index, 1);
    },
    addPropertySuggestion() {
      if (this.$store.getters.supplierProductSelectedForEdit) {
        this.product.propertySuggestions.push({
          id: null,
          title: '',
          value: '',
          listValues: [],
        });
      } else {
        this.product.propertySuggestions.push({
          title: '',
          value: '',
          listValues: [],
        });
      }
    },
    nextStep() {
      //selectedProductProperties && selectedProductProperties?.length
      if (
        this.selectedProductProperties &&
        this.selectedProductProperties?.length == 0
      ) {
        this.nextStepActions();
      }
      if (
        this.selectedProductProperties &&
        this.selectedProductProperties?.length > 0 &&
        this.$refs.ProductForm.validate()
      ) {
        if (this.product.propertySuggestions?.length > 0) {
          if (this.$refs.propertySuggestionForm.validate()) {
            this.nextStepActions();
          } else {
            this.$dialog.error({
              text: 'وارد کردن موارد ستاره دار الزامی میباشد',
              title: 'خطا',
              persistent: true,
              actions: [
                {
                  text: 'بستن',
                  color: 'red',
                },
              ],
            });
          }
        } else {
          this.nextStepActions();
        }
      }

      // else {
      //   this.$dialog.error({
      //     text: 'وارد کردن موارد ستاره دار الزامی میباشد',
      //     title: 'خطا',
      //     persistent: true,
      //     actions: [
      //       {
      //         text: 'بستن',
      //         color: 'red',
      //       },
      //     ],
      //   });
      // }
    },
    nextStepActions() {
      const loader = this.$loading.show();
      const productProperties = [];
      if (this.selectedProductProperties?.length > 0) {
        this.selectedProductProperties.forEach((element) => {
          let stringValue = '';
          if (element.propertyType == 'MultiSelectList') {
            if (element.value && element.value.length > 0) {
              //alert(element.value.length)
              element.value.forEach((val, index) => {
                stringValue = stringValue + val;
                if (index < element.value.length - 1) {
                  stringValue = stringValue + '|';
                }
              });
            }
          }
          let propertiesObject = {
            propertyId: element.propertyId,
            value:
              element.propertyType == 'MultiSelectList'
                ? stringValue
                : element.propertyType == 'File' &&
                  element.value &&
                  element.value.length > 0
                ? element.value[0].fileId
                : element.propertyType == 'Logical' && element.value > 0
                ? element.value.toString()
                : element.value,
            forSupplier: element.forSupplier,
            measurementUnitId:
              element.propertyType == 'Number'
                ? element.mid
                : null,
          };
          if (element.propertyType == 'Number' && element.setMaxValue) {
            propertiesObject.maxValue = element.maxValue;
          }
          if (this.$store.getters.supplierProductIsEdit) {
            propertiesObject.id = element.id ? element.id : null;
          }

          if (
            (!this.$store.getters.supplierProductIsEdit &&
              element.value &&
              !this.isSelectedProduct &&
              element.propertyType != 'MultiSelectList') ||
            element.propertyType != 'File'
          ) {
            productProperties.push(propertiesObject);
          } else if (
            element.value &&
            element.value.length > 0 &&
            (element.propertyType == 'MultiSelectList' ||
              element.propertyType == 'File')
          ) {
            productProperties.push(propertiesObject);
          } else if (
            (!this.$store.getters.supplierProductIsEdit &&
              element.value &&
              element.propertyType != 'MultiSelectList') ||
            element.propertyType != 'File'
          ) {
            productProperties.push(propertiesObject);
          } else if (
            this.$store.getters.supplierProductIsEdit &&
            element.value &&
            element.value.length > 0
          ) {
            productProperties.push(propertiesObject);
          }
        });
      }
      this.$emit('completeProductProperties', {
        properties: productProperties,
        propertySuggestions: this.product.propertySuggestions,
      });
      loader.hide();
    },
  },
};
</script>

<style scoped lang="scss">
.properies-form-font {
  font-family: Iran Sans, yekan-regular !important;
}
.v-label {
  font-family: Iran Sans, yekan-regular !important;
}
input .v-input {
  direction: ltr !important;
  text-align: right !important;
}
</style>
